<template>

    <div


    >


    <div class="d-flex min-vh-100 align-items-center justify-content-center"


  >

    <form @submit.prevent="submit" class="py-4 px-3 border shadow-sm rounded"
          style="opacity: 0.7; border: 1px solid green !important;">
     <div class="text-center mb-4">
<!--        <img class="img-fluid" src="/images/logo.svg" alt="">-->
      </div>
      <b-form-group label="User Name or Email">
        <b-input :state="$v.email_user_name.$error ? false: null" v-model="$v.email_user_name.$model" type="text"
                 size="sm" placeholder="User Name or  Email"/>
        <template #invalid-feedback>
          <ErrorMessages :field="$v.email_user_name" name="user name or email"/>
        </template>
      </b-form-group>
      <b-form-group label="Password">
          <template>
              <b-input-group size="sm" class="mb-2">
                  <b-form-input
                      :state="$v.password.$error ? false : null"
                      :type="showPassword ? 'text' : 'password'"
                      v-model="$v.password.$model"
                      placeholder="******"
                  ></b-form-input>

                  <b-input-group-append>
                      <b-button @click="togglePassword" variant="outline-secondary">
                          <b-icon :icon="showPassword ? 'eye' : 'eye-slash'"></b-icon>
                      </b-button>
                  </b-input-group-append>
              </b-input-group>
          </template>
        <template #invalid-feedback>
          <ErrorMessages :field="$v.password" name="password"/>
        </template>
      </b-form-group>



        <div class="d-flex justify-content-center mt-5">
            <b-button @click="submit"  ref="formSubmit" block  :disabled="fetching" value="Login" class=" col-md-4 btn btn-info text-uppercase">

                <span>Login</span>
                <span v-if="fetching" class="saving-dots ml-1">
                            <span></span><span></span><span></span>
                          </span>
            </b-button>
        </div>

    </form>
  </div>

    </div>
</template>

<script>
import {validationMixin} from 'vuelidate'
import ErrorMessages from "../components/ErrorMessages";
import {loginValidation} from "../validations/loginValidation";
import {mapActions} from "vuex";
import apiService from "../service/apiService";
import {authHeader} from "../helpers/authHeader";
import Swal from "sweetalert2";
import axios from "axios";
import URL from "@/constants/baseurl";

export default {
  name: "Login",
  components: {ErrorMessages},
  mixins: [validationMixin],
  validations: loginValidation,
  data() {
    return {
        twof:'',
         email_user_name: '',
         password: '',
         button_text:'Authenticate with WSO2',
        fetching:false,
        showPassword: false
    }
  },
 async created(){
    await this.processLogoutManual()
  },
  methods: {
    ...mapActions(['login','processLogoutManual']),

      togglePassword() {
          this.showPassword = !this.showPassword
      },

    async submit() {
          this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      const credentials = {
        email_user_name: this.email_user_name,
        password: this.password,
          twof:this.twof
      }
      try{
          this.fetching=true
          let twof; //only one line should be uncommented out of three
           // twof = localStorage.getItem('twof'); // if otp needed only first login
           twof=true // if otp functionality not needed
           // twof=false // if otp functionality needed at every login
          if(twof){
              credentials.twof=twof
              this.twof=twof
              await this.login(credentials)
              apiService.defaults.headers = authHeader()
              // await this.$router.push({path: '/'})
              window.location.href = '/'
          }
          else {
              try {
                  const res = await axios.post(`${URL.BASEURL}/api/two_factor_authentication`,{email_user_name:this.email_user_name,password:this.password});

                  if (res) {

                      try {
                          const { value: twofac,dismiss } = await Swal.fire({
                              title: `Enter OTP`,
                              html: `
                            <div style="display: flex; justify-content: center; align-items: center;">
                              <input id="swal-input-2f"
                                     type="text"
                                     maxlength="6"
                                     inputmode="numeric"
                                     pattern="[0-9]*"
                                     class="swal2-input"
                                     placeholder="● ● ● ● ● ●"
                                     style="text-align: center; letter-spacing: 2px; font-size: 24px; width: 200px; font-weight: bold;" />
                            </div>
                          `,
                              focusConfirm: false,
                              showCancelButton: true,
                              confirmButtonText: 'Verify',
                              cancelButtonText: 'Cancel',
                              preConfirm: () => {
                                  const twofac = Swal.getPopup().querySelector('#swal-input-2f').value.trim();
                                  if (!/^[0-9]{6}$/.test(twofac)) {
                                      Swal.showValidationMessage('Please enter a valid 6-digit code!');
                                  }
                                  return twofac;
                              },
                          });

                          if (dismiss === Swal.DismissReason.cancel || dismiss === Swal.DismissReason.backdrop) {
                              this.fetching = false;
                              return;
                          }


                          if (twofac) {


                                  this.twof=twofac
                              let response=    await this.login({
                                      email_user_name: this.email_user_name,
                                      password: this.password,
                                      twof:twofac
                                  })
                                  //console.log(response,'response here')
                                  if(response.status_code==200){
                                      localStorage.setItem("twof", twofac);
                                    //   Swal.fire('success', 'Thanks for Confirmation', 'success');

                                      apiService.defaults.headers = authHeader()
                                      // await this.$router.push({path: '/'})
                                      window.location.href = '/'
                                  }
                               if(response.status_code==203) {
                                      Swal.fire('Error', 'Code is Invalid, Try Again', 'info');
                                   this.fetching=false
                               }







                          } else {
                              // Handle the code when the user cancels or closes the dialog here
                              //  console.log('User cancelled or closed the dialog');
                          }
                      } catch (error) {
                          this.fetching=false
                         await Swal.fire('Error', 'Something went wrong, Try Again', 'info');
                          console.error(error);
                      }



                  } else {

                  }
              } catch (error) {
                  this.fetching=false
                  await Swal.fire('Error', 'Something went wrong, Try Again', 'info');
                  console.error(error);
                  //  Swal.fire('Error', 'Failed to add Transaction.', 'info');
              }

          }

      }catch(error){
          this.fetching=false
        const makeToast = await import('../helpers/toastMessages').then(mod => mod.makeToast.bind(this))
          makeToast('Invalid credentials, Please try again', 'danger','There was a problem')
        }
    }
  }
}
</script>

<style scoped lang="scss">
form {
  width: 500px;
  background: white;
}

.saving-dots {

    align-items: center;
}

.saving-dots span {
    width: 6px;   /* dot size */
    height: 6px;
    margin: 0 3px;
    background: white;   /* adjust to match button text color */
    border-radius: 50%;
    display: inline-block;
    animation: bounce 1.2s infinite;
}

.saving-dots span:nth-child(1) { animation-delay: 0s; }
.saving-dots span:nth-child(2) { animation-delay: 0.2s; }
.saving-dots span:nth-child(3) { animation-delay: 0.4s; }




</style>
